namespace advisorop.components.identity {

    interface IRegisterFormController extends advisorop.domains.identity.IRegisterFormModel {

        registerUser(): void;

    }

    class RegisterFormController implements IRegisterFormController {

        public email: string;
        public password: string;
        public passwordConfirmation: string;
        public firstName: string;
        public lastName: string;
        public address: string;
        public cellPhone: string;

        static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) {
            this.email = "";
            this.password = "";
            this.passwordConfirmation = "";
        }

        //method for registering user
        registerUser(): void {
            let rez = this.$http.post("/api/account", { email: this.email, password: this.password });
            rez.success(function (data) {
                toastr.info("We are logged in");
            }).error(function (data, status) {
                if (status === 401) {
                    toastr.error("You are not authenticated. Please try again.");
                };
            });
        }
        

        $onInit(): void {
        }
    }



    class RegisterForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                //textBinding: '@',
                //dataBinding: '<',
                //functionBinding: '&'
            };
            this.controller = ["$http", RegisterFormController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/register-form.html';            
        }

    }
    angular.module(Constants.APP).component("registerForm", new RegisterForm());
}